<div class="modal-body" role="dialog" aria-label="Ask Blakey">
  <div class="d-flex justify-content-end" (click)="close()" role="button" tabindex="0" aria-label="Close" (keydown.enter)="close()">
    <img ngSrc="assets/images/close_icon.svg" alt="" width="16" height="16">
  </div>
  <!-- modalContArea -->
  <div class="modalContArea" [formGroup]="form">
    <h4 class="mb-4">
      <img ngSrc="assets/images/ask-blakey-icon.svg" alt="" width="24" height="24">
    {{'Ask Blakey' | translate}}</h4>
    <!-- <p>{{'ruleAssistDesc' | translate}}</p> -->
    <p>David Blake is a <strong>LIV Golf rule Official</strong>, send him a question directly about your rule question</p>
    <p class="sm_txt my-3">
      <b>{{'Question' | translate}}</b><br>
      {{ruleAssistQuestionObject.question}}
    </p>
    <div class="email-wrap">
      <Label>{{'Your Email' | translate}}</Label>
      <input type="email" name="email" class="form-control" formControlName="email"
        [placeholder]="'Enter your email' | translate">
      </div>
      <textarea [readonly]="submitted" name="comment" class="form-control text-question" formControlName="comment"
      [placeholder]="'Type any golf rule question'| translate" autofocus></textarea>
      @if (!submitted) {
        <a href="javascript:void(0)" (click)="!submitting ? submit() : ''"
          class="btn common-btn blck">
          @if (!submitting) {
            {{'Send' | translate}}
          }
          @if (submitting) {
            <img class="btn-img" src="/assets/images/loading-btn.svg" />
          }
        </a>
      }
      @if (submitted) {
        <p class="mt-4 mb-3">{{'ruleAssistPlaceholder' | translate}}</p>
        <a href="javascript:void(0)" (click)="close()" class="btn common-btn blck">{{'GoBackToHome'| translate}}</a>
      }
    </div>
    <!-- modalContArea -->
  </div>